
export default {
  computed: {
    // Default so Vue doesn't warn when components use this mixin without defining certApp.
    // Components like ProfileShowModal.vue override this with their own implementation.
    certApp() {
      return false;
    },
    firstInitial() {
      if (this.firstName === 'N/A') {
        return '';
      }
      return this.firstName.charAt(0).toUpperCase();
    },
    firstName() {
      return this.user.firstName || 'N/A';
    },
    resettableSims() {
      return this.$store.getters['simulationConfigs/all']
        .filter(category => this.isResettable(category.categoryId))
        .filter(category => this.$access(this.$store, 'category', category.categoryId))
        .map(sim => {
          const category = this.$store.getters['categories/categories'][sim.categoryId];
          return ({
            ...sim,
            ...category,
          });
        });
    },
    showAdditionalSettings() {
      return !this.isAse();
    },
    showBookmarksDiscussions() {
      return !this.isAse();
    },
    showUpgrade() {
      const userHasPaid = this.$store.getters['session/hasPaid'];
      const pvar = this.$store.getters['productVars/get']['disable_web_top_bar_upgrade'];
      const disabledByPVar = pvar && (pvar.parsedValue === true);
      return !userHasPaid && !this.certApp && !disabledByPVar;
    },
    testDateConfig() {
      const classificationConfigs = this.$store.getters['userProfileConfigs/get'][this.user.classificationId];
      if (classificationConfigs) {
        return classificationConfigs.filter(config => {
          return config.userProfileColumnName.toLowerCase().includes('testdate');
        }).sort((a, b) => a.order - b.order)[0];
      }
    },
    testDate() {
      const key = this.testDateKey;
      const dateString = this.user.userProfile?.[key];
      if (!dateString) return '';

      const [year, month, day] = dateString.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      return date?.toLocaleDateString() || '';
    },
    testDateKey() {
      if (!this.testDateConfig) return '';
      const config = this.testDateConfig;
      if (!config) return '';
      if (config.dataType !== 'date') return '';

      return config.userProfileColumnName;
    },
    user() {
      return this.$store.getters['user/get'];
    },
  },
  methods: {
    back() {
      this.$store.commit('ui/setProfileModalShown', 'profileShowModal');
    },
    close() {
      this.$store.commit('ui/setProfileModalShown', '');
    },
    isResettable(categoryId) {
      const category = this.$store.getters['categories/categories'][categoryId];
      return category?.userResettable;
    },
    open(modal) {
      this.$store.commit('ui/setProfileModalShown', modal);
    },
    isAse() {
      const bundleIdentifiers = ['com.hltcorp.ase'];
      const currentBundleIdentifier = this.$store.getters['app/bundleIdentifier'];
      return bundleIdentifiers.includes(currentBundleIdentifier);
    },
    stripLeadingZeros(dateStr) {
      const [month, day, year] = dateStr.split('/');
      return `${parseInt(month, 10)}/${parseInt(day, 10)}/${year}`;
    },
    upsell() {
      this.$store.dispatch('ui/toggleUpsellModal', {
        show: true,
        source: {
          type: 'Profile Show Modal',
        },
      } );
    },
  },
};
